import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {NbMenuItem, NbSidebarService} from '@nebular/theme';
import {ThemeService} from '@app/service/theme.service';
import {OktaAuthService, UserClaims} from '@okta/okta-angular';

@Component({
  selector: 'app-correspondence-layout',
  templateUrl: './correspondence-layout.component.html',
  styleUrls: ['./correspondence-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class CorrespondenceLayoutComponent implements OnInit {

  public theme = 'my-light-theme';
  userClaims : UserClaims | undefined;

  menuItems: NbMenuItem[] = [
    {
      title: 'Bulk Pricing',
      icon: 'pricetags-outline',
      children: [
        {
          title: 'Agency Bulk Pricing',
          icon: 'pricetags-outline',
          link: '/correspondence/bulk-tape-upload'
        },
        {
          title: 'NonQM Bulk Pricing',
          icon: 'pricetags-outline',
          link: '/correspondence/bulk-tape-upload'
        },
        {
          title: 'Bulk Pipeline',
          icon: 'pricetags-outline',
          link: '/correspondence/bulk-pipeline'
        },
      ],
    },

  ];

  constructor(
      private themeService: ThemeService,
      private sidebarService: NbSidebarService,
      private oktaAuth: OktaAuthService
  ) {}

  ngOnInit() {

  }

  async onActivate(event) {
    this.userClaims = await this.oktaAuth.getUser();
    this.menuItems = this.menuItems.map(menuItem => {
      if (menuItem.title === 'Bulk Pricing' && this.userClaims.groups.includes('Correspondents')) {
        menuItem.hidden = false;
      }else if (menuItem.title === 'Bulk Pricing' && !this.userClaims.groups.includes('Correspondents')) {
        menuItem.hidden = true;
      } else  {
        menuItem.hidden = true;
      }
      return menuItem;
    });
  }

}
